import { Action } from '@ngrx/store';
import { User } from 'oidc-client';

export const AUTH_CO = '[AUTH] Authentication connection';
export const AUTH_CALLBACK = '[AUTH] Authentication callback';
export const AUTH_CO_SILENT = '[AUTH] Authentication silent';
export const AUTH_CO_REGISTER_REDIRECT_URL = '[AUTH] Authentication register redirectUrl';
export const AUTH_CO_EXTENSION_BEFORE_AUTH_SUCCESS = '[AUTH] Extension - Before Authentication Success';
export const AUTH_CO_EXTENSION_BEFORE_AUTH_SUCCESS_RESPONSE = '[AUTH] Extension Response - Before Authentication Success';
export const AUTH_CO_SUCCESS = '[AUTH] Authentication connection Success';
export const AUTH_CO_FAIL = '[AUTH] Authentication connection Fail';
export const AUTH_DECO = '[AUTH] Authentication deconnection';
export const AUTH_DECO_SUCCESS = '[AUTH] Authentication deconnection Success';
export const AUTH_DECO_FAIL = '[AUTH] Authentication deconnection Fail';
export const AUTH_LOGOUT_COMPLETE = '[AUTH] Logout complete';

/** Action to connect someone */
export class AuthCo implements Action {
    readonly type = AUTH_CO;
    constructor(public payload: string) { }
}


export class AuthCallback implements Action {
  readonly type = AUTH_CALLBACK;

}

export class AuthCoExtensionBeforeAuthSuccess implements Action {
  readonly type = AUTH_CO_EXTENSION_BEFORE_AUTH_SUCCESS;

}

export class AuthCoExtensionBeforeAuthSuccessResponse implements Action {
  readonly type = AUTH_CO_EXTENSION_BEFORE_AUTH_SUCCESS_RESPONSE;

}
export class AuthCoSilent implements Action {
  readonly type = AUTH_CO_SILENT;
  constructor(public payload: User) {}
}

/** Action to valide a connection */
export class AuthCoSuccess implements Action {
  readonly type = AUTH_CO_SUCCESS;

}

/**
 * Action executed once we are redirected back from Authorization Server
 * (post_logout_redirect_uri).
 */
export class LogoutComplete implements Action {
  readonly type = AUTH_LOGOUT_COMPLETE;
  constructor(public payload: {local?}) { }
}

/** Registers the redirectUrl in the store to be able to use it after finishing authentication */
export class AuthRegisterRedirectUrl implements Action {
  readonly type = AUTH_CO_REGISTER_REDIRECT_URL;
  constructor(public payload: {redirectUrl: string}) {}
}

/** Action to refuse a connection */
export class AuthCoFail implements Action {
    readonly type = AUTH_CO_FAIL;
    constructor(public payload: any) {}
}

/** Action to deconnect someone */
export class AuthDeco implements Action {
    readonly type = AUTH_DECO;
    constructor(public payload: {local?}) {}
}

/** Action to valide a deconnection */
export class AuthDecoSuccess implements Action {
    readonly type = AUTH_DECO_SUCCESS;
}

/** Action to refuse a deconnection */
export class AuthDecoFail implements Action {
    readonly type = AUTH_DECO_FAIL;
    constructor(public payload: any) {}
}

/**
 * Workflow classique:
 *
 * <ol>
 * <li>AuthCo: action émise pour initier l'authentification: l'utilisateur est redirigé vers le serveur d'authentification</li>
 * <li>AuthCallback: action émise une fois l'utilisateur authentifié, lorsque le serveur d'authentification
 *     redirige l'utilisateur vers l'application</li>
 * <li>AuthRegisterRedirectUrl: stocke l'url d'origine (avant authentification)</li>
 * <li>AuthCoSilent: continue le processus d'authentification (à noter, peut aussi être appelé
 *     directement pour initier une authentification silencieuse (automatique)</li>
 * <li>[si conf.useExtensions=true] AuthExtensionAuthSuccess: émet l'évènement à destination de librairies tierces</li>
 * <li>[si conf.useExtensions=true] AuthExtensionBeforeAuthSuccessResponse: doit être émis par les librairies tierces</li>
 * <li>AuthCoSuccess: émis en fin d'authentification</li>
 * <li>Go: redirection vers l'url d'origine</li>
 * </ol>
 */
export type AuthAction =
    | AuthCo
    | AuthCoSuccess
    | AuthCoFail
    | AuthCoSilent
    | AuthDeco
    | AuthDecoSuccess
    | AuthRegisterRedirectUrl
    | AuthDecoFail
    | AuthCoExtensionBeforeAuthSuccess
    | AuthCoExtensionBeforeAuthSuccessResponse
;

